import axios from 'axios'
import csrfToken from './utils/csrf-token'

if (! csrfToken()) {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

window.axios = axios.create({
    headers: {
        'X-CSRF-TOKEN': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest',
    }
})

require('./utils/axios-nprogress').load()
require('./utils/axios-error-handler').load()

// Add takeAtLeast method to Promise
/* eslint no-unused-vars: 0 */
Promise.prototype.takeAtLeast = function (time) {
    return new Promise((resolve, reject) => {
        const limiter = new Promise((resolve, reject) => {
            setTimeout(resolve, time);
        })

        Promise.all([this, limiter]).then(([response, _]) => {
            resolve(response)
        }, reject)
    })
}
